<template>
  <div class="box">
    <router-link tag="div" to="/orderlist">
      CURRENT ORDER
    </router-link>
    <router-link tag="div" to="/index">
      NEW ORDER
    </router-link>
  </div>
</template>

<script>
  export default {
    name: "guide-page"
  }
</script>

<style scoped lang="less">
  .box{
    height: 100vh;
    width: 100vw !important;
    display: flex;
    justify-content: space-around;
    align-items: center;
    >div{
      width: 500px;
      height: 200px;
      display: flex;
      align-items: center;
      justify-content: center;
      border: 1px solid #00ffff;
      cursor: pointer;
      font-size: 0.5rem;
      &:hover{
        background: #3a8ee6;
        color: #fff;
        transition: all 0.5s;
      }
    }
  }
</style>



// WEBPACK FOOTER //
// src/components/guidePage.vue